export default __webpack_public_path__ + "static/media/Spinnaker-Regular.e5d1a73d.ttf";